// Docs:
// https://github.com/marmelab/react-admin/issues/1772

import React from 'react';
import {  ReferenceInput, required, SelectInput, SimpleForm, TextInput, SaveButton, Toolbar,
  FormDataConsumer } from 'react-admin';
import { CreateBody } from '../../components/CreateBody';

import { choices as websiteTypes } from '../../components/WebsiteTypes';
import { getDepthChoices } from '../../components/DepthChoices';
import { getFrequencyChoices } from '../../components/FrequencyChoices';
import Tooltip from '@material-ui/core/Tooltip';
import InfoIcon from '@material-ui/icons/Info';
import { withStyles } from '@material-ui/core/styles';
import { validateCanonicalDomain } from '../../utils/validateCanonicalDomain';

const styles = {
  inlineBlock: {
    display: 'inline-block',
  },
};

const DomainSaveToolbar = props => (
  <Toolbar {...props} >
    <SaveButton disabled={props.invalid} data-testid="domain-create-save-button" className="domain-create-save-button"/>
  </Toolbar>
);

class DomainsCreation extends React.Component {

  render() {
    let { classes } = this.props;
    const websiteId = this.props.location.pathname.substring('/domains/create'.length);

    return (
      <CreateBody {...this.props}>
        <SimpleForm redirect={`/websites/${encodeURIComponent(websiteId)}`} toolbar={<DomainSaveToolbar />}>

          <ReferenceInput label="Website"
                          source="website"
                          reference="websites"
                          validate={required()}
                          filterToQuery={searchText => ({name: searchText})}
                          filter={{id: websiteId}}
                          initialValue={websiteId}>
            <TextInput source="name"
                           value={`Website #${websiteId.split('/').pop()}`} disabled/>
          </ReferenceInput>

          <TextInput formClassName={classes.inlineBlock} label="Domain URI" data-testid="add-domain-domain-name-input" source="canonicalDomain"
                     parse={domain => domain.trim().toLowerCase()} validate={validateCanonicalDomain()} />
          <Tooltip formClassName={classes.inlineBlock}
                   title='Provide Hostname without http protocol or www subdomain.'
                   placement="right-end">
            <InfoIcon />
          </Tooltip>

          <SelectInput label="Type"
                       data-testid="add-domain-domain-type-select"
                       source="type"
                       choices={websiteTypes()}
                       validate={required()}/>

          <ReferenceInput key={websiteId}
                          label="Default Language"
                          source="defaultLang"
                          data-testid="default-language"
                          reference="languages"
                          validate={required()}
                          filter={{limit_by_website: websiteId}}
                          sort={{field: "name", order: "ASC"}}>
            <SelectInput optionText="name"
                         optionValue="@id"/>
          </ReferenceInput>

          <FormDataConsumer>
            {({
                formData,
                ...rest
              }) =>
              formData && formData.type === 'website' ? (<div {...rest}>
                  <SelectInput label="Scanning depth"
                               data-testid="add-domain-scanning-depth-select"
                               source="scanningDepth"
                               choices={getDepthChoices()}
                               validate={required()} {...rest} />

                  <SelectInput label="Scanning frequency"
                               data-testid="add-domain-scanning-frequency-select"
                               source="scanningFrequency"
                               choices={getFrequencyChoices()}
                               validate={required()} {...rest} />
                </div>
              ) : null
            }
          </FormDataConsumer>

        </SimpleForm>
      </CreateBody>
    );
  }
}

export const DomainsCreate = withStyles(styles)(DomainsCreation);
